{
  "entrance": [
    "CircleIn",
    "CurveIn",
    "PunchIn",
    "FadeIn",
    "FloatIn",
    "FoldIn",
    "BlurIn",
    "TurnIn",
    "ExpandIn",
    "DropIn",
    "TiltIn",
    "RevealIn",
    "ShapeIn",
    "GlideIn",
    "GlitchIn",
    "ArcIn",
    "FlipIn",
    "GrowIn",
    "WinkIn",
    "SlideIn",
    "SpinIn",
    "BounceIn"
  ],
  "ongoing": [
    "Breathe",
    "Rubber",
    "Flip",
    "Poke",
    "Fold",
    "Pulse",
    "Cross",
    "Wiggle",
    "Bounce",
    "Spin",
    "Jello",
    "Flash",
    "Swing"
],
  "scroll": [
    "TurnScroll",
    "TiltScroll",
    "ParallaxScroll",
    "FadeScroll",
    "SkewPanScroll",
    "PanScroll",
    "GrowScroll",
    "ShrinkScroll",
    "Spin3dScroll",
    "BlurScroll",
    "MoveScroll",
    "FlipScroll",
    "StretchScroll",
    "RevealScroll",
    "SpinScroll",
    "SlideScroll",
    "ShapeScroll",
    "ArcScroll"
  ]
}
